export default __webpack_public_path__ + "static/media/icon_5.d7a23e8e.png";